import { HELP_CENTERS_MANAGEMENT_BASE_PATH } from '@helpcenter/constants';
import FeatureGates from '@atlaskit/feature-gate-js-client/feature-gates';

const HELP_HUB_MIGRATION_GATE = 'enable-help-hub-migration';
const JIRA_SIDEBAR_SHOW_HELPCENTER_EXPERIMENT = 'jira_sidebar_show_helpcenter';

export const getHelpCenterCreationUrl = (jiraDisplayUrl = ''): string =>
	FeatureGates.checkGate(HELP_HUB_MIGRATION_GATE) &&
	FeatureGates.getExperimentValue(JIRA_SIDEBAR_SHOW_HELPCENTER_EXPERIMENT, 'isEnabled', false)
		? `${jiraDisplayUrl}/jira/helpcenter-management?create=true`
		: `${HELP_CENTERS_MANAGEMENT_BASE_PATH}?create=true`;
